module.exports = __webpack_public_path__ + "img/baharkam.fba83cd6.png";